// extracted by mini-css-extract-plugin
module.exports = {"ArticleSubcategories2":"ArticleSubcategories2_ArticleSubcategories2__oCQmD"};